import { Modelo, apiRequest, Log } from '@ext/index';
import moment, { Moment } from 'moment';

export class ArchivoTemporal
{

    public static async Crear( archivo: File, cuenta_mensajeria_ml?: string ): Promise<{ Nombre?: string; URL?: string; }>
    {
        try
        {
            let req = new apiRequest( `/archivos/temporales` );
            req.useformData = true;
            req.formData.append( 'file', archivo );
            if ( cuenta_mensajeria_ml )
                req.formData.append( 'cuenta_mensajeria_ml', cuenta_mensajeria_ml );
            if ( await req.post() )
            {
                return {
                    Nombre: req.data.file_name,
                    URL: req.data.file_url,
                };
            }

        } catch ( e )
        {
            Log( e );
        }
        return null;
    }
}

